import React, { useState } from 'react';
import { Stepper } from 'react-form-stepper';
import PageHeader from '../../../components/PageHeader';
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from './StepFour';
import StepFive from './StepFive';
import { Button, Form } from "react-bootstrap";
import SearchSelect from '../../../components/SearchSelect';
const CreateTicketPage = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [hasParking, setHasParking] = useState(false);

    const handleParkingChange = (e) => {
        setHasParking(e.target.checked);
    };
    const stepForm = [
        {
            id: 1,
            component: (
                <StepOne activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 2,
            component: (
                <StepTwo activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 3,
            component: (
                <StepThree activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 4,
            component: (
                <StepFour activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 5,
            component: (
                <StepFive activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        }
        // { id: 4, component: <StepOne activeStep={activeStep} /> },
    ];
    return (
        <>
            {/* <div className="single-step mt-4"></div> */}
            <PageHeader name="Create Ticket" />
            <div>

                <div className="row justify-content-center">
                    <div className="col-xl-11">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Team Info</h5>
                                    <div className="row">

                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Team:</Form.Label>
                                                {/* <Form.Select>
                                                    <option value="">Team 1</option>
                                                    <option value="">Team 2</option>
                                                </Form.Select> */}
                                                <SearchSelect
                                                    options={
                                                        [
                                                            { value: 'Team 1', label: 'Team 1' },
                                                            { value: 'Team 2', label: 'Team 2' },
                                                            { value: 'Team 3', label: 'Team 3' }
                                                        ]
                                                    }
                                                    placeholder={"Select Lead"}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>identity:</Form.Label>
                                                {/* <Form.Select>
                                                    <option value="">identity 1</option>
                                                    <option value="">identity 2</option>
                                                </Form.Select> */}
                                                <SearchSelect
                                                    options={
                                                        [
                                                            { value: 'Identity 1', label: 'Identity 1' },
                                                            { value: 'Identity 2', label: 'Identity 2' },
                                                            { value: 'Identity 3', label: 'Identity 3' }
                                                        ]
                                                    }
                                                    placeholder={"Select Identity"}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ticket Type:</Form.Label>
                                                {/* <Form.Select>
                                                    <option value="">Type 1</option>
                                                    <option value="">Type 2</option>
                                                </Form.Select> */}
                                                <SearchSelect
                                                    options={
                                                        [
                                                            { value: 'Full', label: 'Full' },
                                                            { value: 'Half', label: 'Half' },
                                                            { value: 'Quarter', label: 'Quarter' },
                                                            { value: 'Mini Plan', label: 'Mini Plan' },
                                                            { value: 'Holiday Pack', label: 'Holiday Pack' },
                                                        ]
                                                    }
                                                    placeholder={"Select Ticket Type"}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Ticket Information</h5>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Account #</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Account No" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Paid:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Paid" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Paid Date:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Paid Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>PO Date:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter PO Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Season Ticket year:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Season Ticket year" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Seating Info</h5>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Section:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Section" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Row:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Row" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Seat #:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Seat #" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label># of Seats:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter # of Seats" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label># of Games:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter # of Games" className="mb-1" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Parking Info</h5>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3 d-flex align-items-center gap-3">
                                                <Form.Label>Parking?</Form.Label>
                                                <Form.Check
                                                    type="checkbox"
                                                    label=""
                                                    onChange={handleParkingChange}
                                                    checked={hasParking}
                                                    className='pt-2 ps-3'
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {hasParking && (
                                            <>
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Parking Location:</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Parking Location" />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label># of Parking Passes:</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter # of Parking Passes" />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Parking Costs:</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Parking Costs" />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Parking PO:</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Parking PO" className="mb-1" />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Parking PO Date:</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Parking PO Date" className="mb-1" />
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className="single-step mt-4">
                                    <h5 className="text-start">Seating Info</h5>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cost per Game per Ticket:</Form.Label>
                                                <Form.Control type="text" placeholder="" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ticket Cost:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Ticket Cost" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Donation:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Donation" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>PSL Cost:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter PSL Cost" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="pslPaid">PSL Paid:</Form.Label>
                                                <div id="pslPaid">
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        label="Yes"
                                                        value="Yes"
                                                        id="pslPaidYes"
                                                        name="pslPaid"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        label="No"
                                                        value="No"
                                                        id="pslPaidNo"
                                                        name="pslPaid"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>PSL Paid Date:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter PSL Paid Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-12 mt-3">
                                            <div className="row justify-content-end">
                                                <div className="col-lg-3 d-flex mb-3">
                                                    <Button
                                                        variant="primary"
                                                        className="text-white mt-auto w-100"
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                                <div className="col-lg-3 d-flex mb-3">
                                                    <Button
                                                        variant="primary"
                                                        className="text-white mt-auto w-100"
                                                    >
                                                        Save
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="single-step mt-4"></div>
                            </div>
                        </div>
                    </div>
                </div>




                {/* <Stepper
                    steps={[{ label: 'Team Info' }, { label: 'Ticket Information' }, { label: 'Seating Info' },{ label: 'Seating Info' }, { label: 'Parking Info' },{ label: 'Ticket Cost' }]}
                    styleConfig={{
                        activeBgColor: "rgba(45, 51, 61, 0.6)",
                        activeTextColor: "#fff",
                        inactiveBgColor: "#fff",
                        inactiveTextColor: "#999",
                        completedBgColor: "rgb(45, 51, 61)",
                        completedTextColor: "#fff",
                        size: "2em",
                    }}
                    activeStep={activeStep+1}
                /> */}
            </div>

            {/* {stepForm[activeStep].component} */}
        </>
    );
};

export default CreateTicketPage;